import React, { Fragment, PureComponent } from 'react';
import { RouteComponentProps } from 'react-router';
import { Container } from 'semantic-ui-react';
import { RUNNER_RUNS_QUERY } from '../../apollo';
import { RunTableCol, SortDir } from '../../types';
import { RunnerSegment } from '../HeaderSegments';
import RunTable from '../RunTable';
import Ad from '../Shared/Ad';

const cols: RunTableCol[] = [
  RunTableCol.Vods,
  RunTableCol.Game,
  RunTableCol.Platform,
  RunTableCol.Category,
  RunTableCol.Event,
  RunTableCol.Runners,
  RunTableCol.Time,
];

interface MatchParams {
  id: string;
}

interface Props extends RouteComponentProps<MatchParams> {}

class RunnerPage extends PureComponent<Props> {
  public render() {
    const { match } = this.props;
    return (
      <Fragment>
        <RunnerSegment runnerId={match.params.id} />
        <Container>
          <Ad key="RunnerPage" />
          <RunTable
            key={`runner-${match.params.id}`}
            query={RUNNER_RUNS_QUERY}
            queryVars={{ runner: match.params.id }}
            defaultSortCol={RunTableCol.Event}
            defaultSortDir={SortDir.Descending}
            cols={cols}
          />
        </Container>
      </Fragment>
    );
  }
}

export default RunnerPage;
export { RunnerPage };
